import { render, staticRenderFns } from "./VerificationMethodSelectionStep.vue?vue&type=template&id=5649b56b&scoped=true&"
import script from "./VerificationMethodSelectionStep.vue?vue&type=script&lang=js&"
export * from "./VerificationMethodSelectionStep.vue?vue&type=script&lang=js&"
import style0 from "./VerificationMethodSelectionStep.vue?vue&type=style&index=0&id=5649b56b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5649b56b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3358805848/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5649b56b')) {
      api.createRecord('5649b56b', component.options)
    } else {
      api.reload('5649b56b', component.options)
    }
    module.hot.accept("./VerificationMethodSelectionStep.vue?vue&type=template&id=5649b56b&scoped=true&", function () {
      api.rerender('5649b56b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/components/customer/authorizations/shared/VerificationMethodSelectionStep.vue"
export default component.exports